import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { Hero } from '@/components/home/Hero';
import { ServicesTeaser } from '@/components/home/ServicesTeaser';
import { WhyYBro } from '@/components/home/WhyYBro';
import { ContactCTA } from '@/components/home/ContactCTA';
import Seo from '@/components/Seo';

export default function HomePage() {
  return (
    <Layout>
      <Seo
        title="Review Management, Local SEO & Compliance"
        description="Turn reviews into growth with GBP management, review response, local SEO, and UK DMCC compliance support."
        path="/"
      />
      <Hero />
      <ServicesTeaser />
      <WhyYBro />
      <ContactCTA />
    </Layout>
  );
}
